import type { FamilyId } from '../schema';

/**
 * 1 ファミリー = 1 skeleton + 1 theme + 1 archetype の固定マッピング。
 * AI 分類はファミリーだけを判断し、残りはこのテーブルが決定する。
 * 生成できる LP パターンは合計 8 通り（ファミリー数）。
 */
export type FamilyPreset = {
  familyId: FamilyId;
  skeletonId: string;
  themeId: string;
  archetypeId: string;
};

export const FAMILY_PRESETS: Record<FamilyId, FamilyPreset> = {
  btob_inquiry: {
    familyId: 'btob_inquiry',
    skeletonId: 'skeleton_btob_inquiry_default',
    themeId: 'theme_corporate_clean',
    archetypeId: 'jp_b2b_trust_authority',
  },
  saas_ai_inquiry: {
    familyId: 'saas_ai_inquiry',
    skeletonId: 'skeleton_saas_ai_inquiry_default',
    themeId: 'theme_modern_trust',
    archetypeId: 'jp_saas_ui_showcase',
  },
  regional_service_inquiry: {
    familyId: 'regional_service_inquiry',
    skeletonId: 'skeleton_regional_service_inquiry_default',
    themeId: 'theme_regional_chain',
    archetypeId: 'jp_regional_service_trust',
  },
  store_reservation: {
    familyId: 'store_reservation',
    skeletonId: 'skeleton_store_reservation_default',
    themeId: 'theme_natural_warm',
    archetypeId: 'jp_local_reassurance',
  },
  d2c_purchase: {
    familyId: 'd2c_purchase',
    skeletonId: 'skeleton_d2c_purchase_default',
    themeId: 'theme_premium_minimal',
    archetypeId: 'jp_d2c_offer_focus',
  },
  seminar_application: {
    familyId: 'seminar_application',
    skeletonId: 'skeleton_seminar_application_default',
    themeId: 'theme_formal_trust',
    archetypeId: 'jp_event_authority_conversion',
  },
  education_application: {
    familyId: 'education_application',
    skeletonId: 'skeleton_education_application_default',
    themeId: 'theme_trust_neutral',
    archetypeId: 'jp_event_authority_conversion',
  },
  recruitment_entry: {
    familyId: 'recruitment_entry',
    skeletonId: 'skeleton_recruitment_entry_default',
    themeId: 'theme_trust_neutral',
    archetypeId: 'jp_recruit_story_culture',
  },
};

export function getFamilyPreset(familyId: FamilyId): FamilyPreset {
  return FAMILY_PRESETS[familyId];
}
